import { render, staticRenderFns } from "./contract-sign.vue?vue&type=template&id=08acda08&scoped=true&"
import script from "./contract-sign.vue?vue&type=script&lang=js&"
export * from "./contract-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08acda08",
  null
  
)

export default component.exports